/**
 * Dev-only rewrite so ``/mobile-viewer`` can hit Docker mobile-service.
 *
 * Production builds return the gateway URL unchanged: ``NODE_ENV`` is inlined,
 * so the override is not read from a production bundle. In dev, the override
 * must be a loopback ``http://localhost`` or ``http://127.0.0.1`` origin.
 * Anything else is ignored, so a mis-set variable cannot send the bearer token
 * to another host.
 *
 * Set ``NEXT_PUBLIC_MOBILE_SERVICE_LOCAL_BASE_URL`` in ``.env.local.dev``
 * (for example ``http://localhost:8000``). Unset → the deployed cell. Restart
 * ``npm run dev`` after changing it.
 */
const LOOPBACK_MOBILE_ORIGIN = /^http:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/;

export function maybeLocalMobileUrl(gatewayUrl: string): string {
  if (process.env.NODE_ENV === 'production') return gatewayUrl;

  const base = process.env.NEXT_PUBLIC_MOBILE_SERVICE_LOCAL_BASE_URL?.trim().replace(/\/$/, '');
  if (!base || !LOOPBACK_MOBILE_ORIGIN.test(base)) return gatewayUrl;

  try {
    const gateway = new URL(gatewayUrl);
    const local = new URL(base);
    gateway.protocol = local.protocol;
    gateway.host = local.host;
    return gateway.toString();
  } catch {
    return gatewayUrl;
  }
}
